// Altera o status de um pedido
(function () {
  'use strict';

  // Variáveis
  const $btnAlteraStatus = $('.pedido-btn-status');
  const $modalStatus = $('#modal-pedido-status');

  // Evento de click ao clicar no botão para alterar o status
  $btnAlteraStatus.on('click', function (ev) {
    ev.preventDefault();
    showModalStatus($(this));
  });

  // Exibe o modal para alteração de status
  function showModalStatus($btn) {
    $('#msp_pedido_id').val($btn.data('pedido-id'));
    $('#msp_status_antigo').val($btn.data('pedido-status'));
    $('#msp-cod').text($btn.data('pedido-cod'));
    $('#msp-data').text($btn.data('pedido-data'));
    $('#msp-horario').text($btn.data('pedido-horario'));
    $('#msp-horario').text($btn.data('pedido-horario'));
    $('#msp-status-badge').html($btn.data('pedido-status-badge'));
    $modalStatus.modal('show');
  }
})();

// Variantes
(function () {
  'use strict';

  if ($('#modal-editar-variante').length > 0) {
    const $btnEditarVariante = $('.btn-editar-variante');
    const $modalEditarVariante = $('#modal-editar-variante');
    const $tableVariants = $('.table-variantes');
    const $cardProdutoTitulo = $('.card-produto-titulo');
    var listaVariantes = [];
    const tabelaHtml = (item) => `
    <tr data-row="${item['id']}">
      <td>
        <div class="form-check">
          <input type="radio" name="variante_id" id="variante-row-${item['id']}" ${item['checked'] ? 'checked' : ''
      } class="check-row" value="${item['id']}">
          <label for="variante-row-${item['id']}" title="Selecionar variante"><span>${item['title']}</span></label>
        </div>
      </td>
      <td data-label="Foto">
        <label for="variante-row-${item['id']}" style="cursor: pointer;">
          <img src="${item['foto_thumb']}" />
        </label>
      </td>
      <td data-label="Variante">
        <label for="variante-row-${item['id']}" style="cursor: pointer;">${item['title']}</label>
      </td>
      <td data-label="Preço">
        <label for="variante-row-${item['id']}">R$ ${formatMoneyBR(item['sale_price'])}</label>
      </td>
      <td data-label="SKU">
        <label for="variante-row-${item['id']}">${item['sku']}</label>
      </td>
    </tr>
    `;

    $btnEditarVariante.on('click', function (ev) {
      var dataJsonVariante = $(this).data('variantjson');
      var tituloProduto = $(this).data('produto-titulo');
      $modalEditarVariante.find('input[name="variantes_json"]').val(dataJsonVariante);
      try {
        dataJsonVariante = jsonParser(dataJsonVariante);
        $cardProdutoTitulo.text(tituloProduto);
        montaListaVariantes(dataJsonVariante);
        populaListaVariantes();
      } catch (e) {
        console.log('falha ao converter!');
        console.log(e);
      }
    });

    function populaListaVariantes() {
      $modalEditarVariante.find('input[name="produto_id"]').val(listaVariantes[0].product_id);
      $tableVariants.find('tbody').html('');
      listaVariantes.map((item) => {
        $tableVariants.find('tbody').append($(tabelaHtml(item)));
      });
    }

    function montaListaVariantes(dataJson) {
      listaVariantes = dataJson;
    }
  }
})();

// Enviar pedido para agendamento melhor envio
(function () {
  'use strict';
  $('.pedido-btn-melhorenvio').on('click', function (ev) {
    ev.preventDefault();
    const urlPedidoMe = $(this).data('url');
    let isLoading = false;
    if (!isLoading) {
      showConfirm({
        type: 'default',
        title: 'Enviar para o Melhor Envio',
        text: 'Deseja enviar este pedido para o Melhor Envio?',
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        callback: function () {
          sendOrderMelhorEnvio(urlPedidoMe);
        },
      });
    }
    function sendOrderMelhorEnvio(urlPedidoMe) {
      showLoader();
      $.getJSON(urlPedidoMe, function (resp) {
        console.log(resp);
        hideLoader();
        if (resp.status == 'success') {
          Toast.fire({
            type: 'success',
            title: 'Enviado para agendamento do Melhor Envio com sucesso.',
          });
          setTimeout(() => {
            location.reload();
          }, 2000);
        } else {
          isLoading = false;
          if(resp.mensagem != ''){
            Toast.fire({
              type: 'error',
              title: resp.mensagem,
            });
          }else{
            Toast.fire({
              type: 'error',
              title: 'Não foi possível realizar o agendamento no Melhor Envio.',
            }); 
          }
        }
      }).fail(function (resp) {
        console.log(resp);
        hideLoader();
        isLoading = false;
        Toast.fire({
          type: 'error',
          title: 'Não foi possível enviar o pedido.',
        });
      });
    }
  });
})();


// Enviar pedido para agendamento manda bem
(function () {
  'use strict';
  $('.pedido-btn-mandabem').on('click', function (ev) {
    ev.preventDefault();
    const urlPedidoMb = $(this).data('url');
    let isLoading = false;
    if (!isLoading) {
      showConfirm({
        type: 'default',
        title: 'Enviar para o Manda Bem',
        text: 'Deseja enviar este pedido para o Manda Bem?',
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        callback: function () {
          sendOrderMandaBem(urlPedidoMb);
        },
      });
    }
    function sendOrderMandaBem(urlPedidoMb) {
      showLoader();
      $.getJSON(urlPedidoMb, function (resp) {
        console.log(resp);
        hideLoader();
        if (resp.status == 'success') {
          Toast.fire({
            type: 'success',
            title: 'Enviado para agendamento do Manda Bem com sucesso.',
          });
          setTimeout(() => {
            location.reload();
          }, 2000);
        } else {
          isLoading = false;
          Toast.fire({
            type: 'error',
            title: 'Não foi possível realizar o agendamento no Manda Bem.',
          });
        }
      }).fail(function (resp) {
        console.log(resp);
        hideLoader();
        isLoading = false;
        Toast.fire({
          type: 'error',
          title: 'Não foi possível enviar o pedido.',
        });
      });
    }
  });
})();

// Enviar pedido para a Shopify
(function () {
  'use strict';
  $('[data-send-order-shopify]').on('click', function (ev) {
    ev.preventDefault();
    const urlApi = $(this).data('send-order-shopify');
    let isLoading = false;
    if (!isLoading) {
      showConfirm({
        type: 'default',
        title: 'Enviar Pedido',
        text: 'Deseja enviar este pedido para a Shopify?',
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        callback: function () {
          sendOrderShopify(urlApi);
        },
      });
    }
    function sendOrderShopify(urlOrder) {
      showLoader();
      $.getJSON(urlOrder, function (resp) {
        console.log(resp);
        hideLoader();
        if (resp.status == 'ok') {
          Toast.fire({
            type: 'success',
            title: 'Pedido enviado com sucesso.',
          });
          setTimeout(() => {
            location.reload();
          }, 2000);
        } else {
          isLoading = false;
          Toast.fire({
            type: 'error',
            title: 'Não foi possível enviar o pedido.',
          });
        }
      }).fail(function (resp) {
        console.log(resp);
        hideLoader();
        isLoading = false;
        Toast.fire({
          type: 'error',
          title: 'Não foi possível enviar o pedido.',
        });
      });
    }
  });
})();

// Enviar pedido para a Dsers
(function () {
  'use strict';
  $('[data-send-order-dsers]').on('click', function (ev) {
    ev.preventDefault();
    const urlApi = $(this).data('send-order-dsers');
    let isLoading = false;
    if (!isLoading) {
      showConfirm({
        type: 'default',
        title: 'Enviar Pedido',
        text: 'Deseja enviar este pedido para a Dsers?',
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        callback: function () {
          sendOrderDsers(urlApi);
        },
      });
    }
    function sendOrderDsers(urlOrder) {
      showLoader();
      $.getJSON(urlOrder, function (resp) {
        console.log(resp);
        hideLoader();
        if (resp.status == 'ok') {
          Toast.fire({
            type: 'success',
            title: 'Pedido enviado com sucesso.',
          });
          setTimeout(() => {
            location.reload();
          }, 2000);
        } else {
          isLoading = false;
          Toast.fire({
            type: 'error',
            title: 'Não foi possível enviar o pedido.',
          });
        }
      }).fail(function (resp) {
        console.log(resp);
        hideLoader();
        isLoading = false;
        Toast.fire({
          type: 'error',
          title: 'Não foi possível enviar o pedido.',
        });
      });
    }
  });
})();

// Enviar pedido para o bling
(function () {
  'use strict';
  $('[data-send-order-bling]').on('click', function (ev) {
    ev.preventDefault();
    const urlApi = $(this).data('send-order-bling');
    let isLoading = false;
    if (!isLoading) {
      showConfirm({
        type: 'default',
        title: 'Enviar Pedido',
        text: 'Deseja enviar este pedido para o Bling?',
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        callback: function () {
          sendOrderBling(urlApi);
        },
      });
    }
    function sendOrderBling(urlOrder) {
      showLoader();
      $.getJSON(urlOrder, function (resp) {
        console.log(resp);
        hideLoader();
        if (resp.status == 'ok') {
          Toast.fire({
            type: 'success',
            title: 'Pedido agendado para envio com sucesso.',
          });
          setTimeout(() => {
            location.reload();
          }, 2000);
        } else {
          isLoading = false;
          Toast.fire({
            type: 'error',
            title: 'Não foi possível enviar o pedido.',
          });
        }
      }).fail(function (resp) {
        console.log(resp);
        hideLoader();
        isLoading = false;
        Toast.fire({
          type: 'error',
          title: 'Não foi possível enviar o pedido.',
        });
      });
    }
  });
})();

// Enviar produto para o bling
(function () {
  'use strict';
  $('[data-send-product-bling]').on('click', function (ev) {
    ev.preventDefault();
    const urlApi = $(this).data('send-product-bling');
    let isLoading = false;
    if (!isLoading) {
      showConfirm({
        type: 'default',
        title: 'Cadastrar Produto',
        text: 'Deseja cadastrar este produto no Bling?',
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        callback: function () {
          sendProductBling(urlApi);
        },
      });
    }
    function sendProductBling(urlOrder) {
      showLoader();
      $.getJSON(urlOrder, function (resp) {
        console.log(resp);
        hideLoader();
        if (resp.status == 'ok') {
          Toast.fire({
            type: 'success',
            title: 'Produto agendado para cadastro com sucesso.',
          });
          setTimeout(() => {
            location.reload();
          }, 2000);
        } else {
          isLoading = false;
          Toast.fire({
            type: 'error',
            title: 'Não foi possível cadastro o produto.',
          });
        }
      }).fail(function (resp) {
        console.log(resp);
        hideLoader();
        isLoading = false;
        Toast.fire({
          type: 'error',
          title: 'Não foi possível cadastro o produto.',
        });
      });
    }
  });
})();

// Cancela / remove uma nota
(function () {
  'use strict';

  // Variáveis
  const $btnNfCancel = $('.btn-nf-cancel');
  const $btnNfRemove = $('.btn-nf-remove');
  const $modalNfActions = $('#modal-nf-actions');
  const $formRemoveNf = $('#form-remove-nf');
  const $nfId = $('#nf-id-remove');
  const $nfAcao = $('#nf-acao-remove');

  // Evento de click ao clicar no botão para cancelar a nota
  $btnNfCancel.on('click', function (ev) {
    ev.preventDefault();
    showModalNfActions($(this));
  });

  // Exibe o modal para alteração de status
  function showModalNfActions($btn) {
    $('#nf_order_id').val($btn.data('order-id'));
    $('#nf_nf_id').val($btn.data('nf-id'));
    $('#nf-acao-cancel').val($btn.data('acao'));
    $modalNfActions.modal('show');
  }

  // Evento de click ao clicar no botão remover nota
  $btnNfRemove.on('click', function (ev) {
    ev.preventDefault();
    $nfId.val($(this).data('nf-id'));
    $nfAcao.val($(this).data('acao'));
    showConfirm({
      type: 'danger',
      title: 'Remover nota fiscal',
      text: 'Confirma a remoção da nota fiscal?',
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar',
      callback: function () {
        $formRemoveNf.submit();
      },
    });
  });
})();

// Captura ou cancela a transação
(function () {
  'use strict';

  // Variáveis
  const $btnCaptura = $('.btn-captura-transacao');
  const $formCaptura = $('#form-transacao-captura');
  const $campoTransacaoID = $('#fct_status');
  const $campoTransacaoAction = $('#fct_acao');
  const $campoTransacaoProcessor = $('#fct_processor');
  const $campoTransacaoStatusValue = $('#fct_value');
  const $campoTransacaoCod = $('#fct_cod');
  const $campoTransacaoAmount = $('#fct_amount');

  // Configurações
  const opts = [
    {
      type: 'danger',
      title: 'Cancelar Transação',
      text: 'Deseja cancelar essa transação?',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    },
    {
      type: 'default',
      title: 'Aprovar Transação',
      text: 'Deseja aprovar (capturar) essa transação?',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    },
    {
      type: 'danger',
      title: 'Devolver pagamento',
      text: 'Confirma a devolução?',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    },
    {
      type: 'default',
      title: 'Sincronizar Status',
      text: 'Confirma a sincronização?',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    },
  ];

  // Evento de click ao clicar no botão //
  $btnCaptura.on('click', function (ev) {
    ev.preventDefault();
    const $btn = $(this);
    const transacaoID = $btn.data('transacao');
    const transacaoStatus = $btn.data('value');
    const transacaoAction = $btn.data('acao');
    const transacaoProcessor = $btn.data('processor');
    const transacaoStatusValue = $btn.data('value');
    const transacaoCod = $btn.data('cod');
    const transacaoAmount = $btn.data('amount');
    $campoTransacaoID.val(transacaoID);
    $campoTransacaoAction.val(transacaoAction);
    $campoTransacaoProcessor.val(transacaoProcessor);
    $campoTransacaoStatusValue.val(transacaoStatusValue);
    $campoTransacaoCod.val(transacaoCod);
    $campoTransacaoAmount.val(transacaoAmount);
    showConfirm({
      type: opts[transacaoStatus].type,
      title: opts[transacaoStatus].title,
      text: opts[transacaoStatus].text,
      confirmButtonText: opts[transacaoStatus].confirmButtonText,
      cancelButtonText: opts[transacaoStatus].cancelButtonText,
      callback: function () {
        $formCaptura.submit();
      },
    });
  });
})();

// Importação pedidos
(function () {
  'use strict';

  const $modalDsers = $('#modal-dsers');
  if ($modalDsers.length > 0) {
    const $linhaStatus = $('#linha_status_importacao');
    if (!$linhaStatus.data('json')) {
      return;
    }
    const $tabelaStatus = $('.table-status-importacao');
    const $btnReprocessar = $('#btn_reprocessar');
    var intervalStatus = null;
    const status = ['finalizado', 'interrompido', 'cancelado', , 'iniciado'];
    const statusClasse = {
      finalizado: 'badge-success',
      cancelado: 'badge-danger',
      interrompido: 'badge-danger',
      iniciado: 'badge-warning',
    };
    var recarregar = false;
    var maximo_atualizacoes = 100;
    const htmlLinhaTabela = (registro) => `
      <td style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">${registro.id}</td>
      <td style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">${registro.progresso}/${registro.total_registros
      }</td>
      <td style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"><span class="badge badge-pill ${statusClasse[registro.status.toLowerCase()]
      }">${registro.status}</span></td>
    `;
    $modalDsers.on('show.bs.modal', modalOpen);
    function modalOpen() {
      var jsonDados = $linhaStatus.data('json');
      recarregar = true;
      atualizaStatusTabela();
      if (jsonDados) {
        if (['interrompido', 'cancelado'].includes(jsonDados.status)) {
          $btnReprocessar.show();
        }
        // const extra = JSON.parse(jsonDados.extra);
        const dadosTabela = {
          ...jsonDados,
        };
        dadosTabela['status'] = dadosTabela['status'].charAt(0).toUpperCase() + dadosTabela['status'].slice(1);
        populaTabela(dadosTabela);
      }
    }

    function atualizaStatusTabela() {
      const response = getStatusImportacao();
      return response.done((result) => {
        if (result) {
          // const extra = JSON.parse(result.registro.extra);
          const dadosTabela = {
            ...result.registro,
          };
          if (dadosTabela['status'] == 'finalizado') {
            $btnReprocessar.hide();
          }
          dadosTabela['status'] = dadosTabela['status'].charAt(0).toUpperCase() + dadosTabela['status'].slice(1);
          populaTabela(dadosTabela);

          if (['interrompido', 'cancelado'].includes(dadosTabela['status'].toLowerCase())) {
            $btnReprocessar.show();
          }

          if (recarregar && maximo_atualizacoes > 0) {
            setTimeout(() => {
              maximo_atualizacoes--;
              atualizaStatusTabela();
            }, 2000);
          } else {
          }
        }
      });
    }

    function populaTabela(registro) {
      $tabelaStatus.find('tbody').html(htmlLinhaTabela(registro));
    }

    $modalDsers.on('hide.bs.modal', modalClose);
    function modalClose() {
      recarregar = false;
      maximo_atualizacoes = 100;
    }

    function getStatusImportacao() {
      // console.log('fazendo fetch...');
      const tokenParam = $modalDsers.find('input[name="token"]');
      const urlGet = $linhaStatus.data('url');
      const data = {
        acao: 'import_dsers_status',
        token: tokenParam.val(),
      };

      return $.ajax({
        type: 'GET',
        url: urlGet,
        data: data,
        dataType: 'json',
      });
    }
  }
})();

// Emitir nota fiscal
(function () {
  'use strict';

  // Variáveis
  const $btnNota = $('.btn-emitir-nota-fiscal');
  const $formNota = $('#form-nota-fiscal');

  const $btnEtiquetaMelhorEnvio = $('.btn-emitir-etiqueta-melhor-envio');
  const $formEtiquetaMelhorEnvio = $('#form-etiqueta-melhor-envio');

  const $btnEtiquetaMelhorEnvioCancel = $('.btn-cancelar-etiqueta-melhor-envio');
  const $formEtiquetaMelhorEnvioCancel = $('#form-etiqueta-melhor-envio-cancel');

  // Configurações
  const opts = [
    {
      type: 'danger',
      title: 'Cancelar Transação',
      text: 'Deseja cancelar essa transação?',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    },
    {
      type: 'default',
      title: 'Aprovar Transação',
      text: 'Deseja aprovar (capturar) essa transação?',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    },
  ];

  // Evento de click ao clicar no botão
  $btnNota.on('click', function (ev) {
    const acaoNf = $(this).data('acao');
    console.log(acaoNf);
    $('#acao_form_nf').val(acaoNf);
    ev.preventDefault();
    showConfirm({
      type: 'default',
      title: 'Emitir Nota Fiscal',
      text: 'Deseja emitir a nota fiscal para este pedido?',
      confirmButtonText: 'Emitir Nota',
      cancelButtonText: 'Cancelar',
      callback: function () {
        $formNota.submit();
      },
    });
  });

  // Evento de click ao clicar no botão
  $btnEtiquetaMelhorEnvio.on('click', function (ev) {
    ev.preventDefault();
    showConfirm({
      type: 'default',
      title: 'Comprar etiqueta - Melhor Envio',
      text: 'Confirma a compra da etiqueta?',
      confirmButtonText: 'Comprar etiqueta',
      cancelButtonText: 'Cancelar',
      callback: function () {
        $formEtiquetaMelhorEnvio.submit();
      },
    });
  });

  // Evento de click ao clicar no botão cancelar etiqueta
  $btnEtiquetaMelhorEnvioCancel.on('click', function (ev) {
    ev.preventDefault();
    $('#me_label_id').val($(this).data('id'));
    showConfirm({
      type: 'danger',
      title: 'Cancelar etiqueta - Melhor Envio',
      text: 'Confirma o cancelamento da etiqueta?',
      confirmButtonText: 'Cancelar etiqueta',
      cancelButtonText: 'Não cancelar etiqueta',
      callback: function () {
        $formEtiquetaMelhorEnvioCancel.submit();
      },
    });
  });
})();

// Gera etiqueta simples de envio para impressão
(function () {
  'use strict';
  $('.btn-print-es').on('click', function (ev) {
    ev.preventDefault();
    $('.es-wrp').printThis();
  });
})();

// Imprimi a página do pedido
(function () {
  'use strict';
  $('.btn-print-order').on('click', function (ev) {
    ev.preventDefault();
    $('.content-wrapper').printThis({
      loadCSS: urlBase + 'app/assets/dist/css/print_order.css',
    });
  });
})();

// Filtro por produto
/* (function () {
  'use strict';
  $('#filtro_produto').on('change', function () {
    let prodFiltro = $(this).val();
    if (prodFiltro == 'all') {
      prodFiltro = '';
    }
    $('#filtro').find('input[name="produto"]').val(prodFiltro);
    $('#filtro').submit();
  });
})(); */

// Filtro por status
(function () {
  'use strict';
  $('.filter-status-item input').on('change', function () {
    let checkedValues = [];
    $('.filter-status-item input:checked').each(function () {
      checkedValues.push($(this).val());
    });
    checkedValues = checkedValues.join(',');
    $('#filtro').find('input[name="status_pedido"]').val(checkedValues);
    $('#filtro').submit();
  });
  if ($('.filter-status-item').length > 0) {
    checkFiltersOnLoad();
  }
  function checkFiltersOnLoad() {
    let valuesFilter = $('#filtro').find('input[name="status_pedido"]').val();
    valuesFilter = valuesFilter ? valuesFilter.split(',') : [];
    valuesFilter.forEach((valueItem) => {
      $('.filter-status-item input[value="' + valueItem + '"]').prop('checked', true);
    });
  }
})();
